import { APP_FONT_STACK, applyStoredAppFont } from "@/lib/appFont";

// Feature-scoped cream palette for BatchWorkbench, mirroring the
// /dashboard-2 (QueryDashboard) design so the run view feels like a continuation
// of it. Applied via inline styles because Tailwind can't emit classes built
// from JS variables at build time.
export const CREAM = {
  ink: "#1F2753", // primary text / dark controls
  warm: "#FFF9F1", // text/icon on top of ink
  mute: "#5A5D70", // secondary text
  bg: "#FCFAF4", // canvas — same cream as QueryDashboard / start page
  nav: "#FCFAF4", // matches the app left nav (NewSideBar bg) — used for the top header
  panel: "#F8F4EC", // rails, headers, toolbars
  card: "#FFFEFC", // card body background
  success: "#587E37", // reviewed / complete controls
  successTint: "rgba(88,126,55,0.10)",
  accent: "#3E6E90", // muted accent for badges / active states (video counts, tabs, scrubber)
  resizeAccent: "#2761d9", // brand blue — used only for card resize/expand affordances
  border: "rgba(31,39,83,0.055)",
  borderSoft: "rgba(31,39,83,0.035)",
  // Borders meant to be *read* rather than felt: list-row outlines and the like.
  borderStrong: "rgba(31,39,83,0.14)",
  // Hairlines that have to survive on their own at 1px — e.g. tree connectors.
  line: "rgba(31,39,83,0.30)",
  hover: "rgba(31,39,83,0.04)",
  hoverStrong: "rgba(31,39,83,0.08)",
  placeholder: "#9a9ba6",
  font: APP_FONT_STACK,
} as const;

/** Selected episode row and the Events bar under it. A shadow is not enough: the bar sits on a white panel. */
export const SELECTED_RAIL_FILL = `linear-gradient(${CREAM.hoverStrong}, ${CREAM.hoverStrong}), ${CREAM.card}`;

/** Apply the saved UI font. The family itself is loaded once at startup. */
export function ensureCreamFont() {
  applyStoredAppFont();
}
